// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"1496051a","834":"71a24f7e"}[chunkId] + ".chunk.js";
};